var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: 0,
    fillRule: "evenodd",
    transform: "translate(-280 -1935)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1076,
    height: 2462,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3 7 3 9 10.02 9 7.536 11.485 8.95 12.899 13.899 7.95 8.95 3 7.536 4.414 10.02 7",
    transform: "translate(280 1935)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.52bcc12451f3d1ed5e6914dfb18e41a8.svg";
export { ForwardRef as ReactComponent };